<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card v-if="!loading">
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="procedure">{{ $tc('title.procedures', 1) }} <required-field /></label>
                <b-form-input aria-describedby="procedure" :state="errors.some((e) => e.field === 'procedure')?false:null"
                              type="text" id="procedure" :value="getProcedureModelLabel" aria-required="true"
                              disabled
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="source">{{ $tc('title.sources', 0) }} <required-field /></label>
                <b-form-input aria-describedby="source" :state="errors.some((e) => e.field === 'source')?false:null"
                              type="text" id="source" :value="getProcedureModelSource" aria-required="true"
                              disabled
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="model">{{$tc('title.models', 1)}} <required-field /> </label>
                <v-select id="model" v-model="model" :options="models" :getOptionLabel="getParsedModel"></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="handleConfirmUpdate">
                {{ $t('actions.save') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'procedureModelRoute'}" push>
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
        <!-- Modal Component -->
        <b-modal title="Conferma Modifica Associazione Prestazione - Modello" class="modal-danger" v-model="updateModal" @ok="updateProcedureModel"
                 size="lg"
                 ok-variant="danger">
          {{ $t('procedureModel.message.confirmUpdate.confirm') }}
          <div class="my-2">
            <h4 class="my-0">Prestazione: {{ getProcedureModelLabel }}</h4>
            <h4 class="my-0">Modello: {{ procedureModel.modelCode }}</h4>
          </div>
          {{ $t('procedureModel.message.confirmUpdate.warning') }}
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr' //ES6
import PageTitle from '@/components/PageTitle'
import RequiredField from "../../components/RequiredField";
import vSelect from 'vue-select'
import ModelService from "@/services/ModelService";
import ProcedureModelService from "@/services/ProcedureModelService";

const modelService = ModelService.build();
const procedureModelService = ProcedureModelService.build();

export default {
  name: 'ProcedureModelEdit',
  inheritAttrs: false,
  components: {
    RequiredField,
    PageTitle,
    vSelect,
  },
  props: {
    id: {
      required: true
    }
  },
  data() {
    return {
      procedureModel: {},
      model: null,
      models: [],
      errors: [],
      loading: false,
      updateModal: false
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    this.getModels();
    this.fetchData();
  },
  computed: {
    getProcedureModelLabel() {
      return this.procedureModel.procedureCode + ' ' + this.procedureModel.procedureLabel
    },
    getProcedureModelSource() {
      return this.procedureModel.sourceLabel
    },
  },
  methods: {
    async fetchData() {
      this.loading = true;

      try {
        this.procedureModel = await procedureModelService.read(this.id)
        this.model = (await modelService.fetchByCode(this.procedureModel.modelCode));
      } catch (exception) {
        console.error(exception)
        exception.errors.forEach(function (element) {
          miniToastr.error(element.message);
        });
      } finally {
        this.loading = false;
      }
    },
    async updateProcedureModel() {
      try {

        await procedureModelService.update(
          {
            id: this.procedureModel.id,
            procedureCode: this.procedureModel.procedureCode,
            modelCode: this.model ? this.model.code : '',
            sourceCode: this.procedureModel.sourceCode
          }
        )
        this.$router.push({name: 'procedureModelShowRoute', params: {id: this.id}})
        miniToastr.info("Associazione Prestazione - Modello aggiornata con successo");
      } catch (exception) {
        this.errors = exception.errors
        exception.errors.forEach(function (element) {
          miniToastr.error(element.message);
        });
      }
    },
    async getModels() {
      this.models = (await modelService.search({ max: -1 })).data;
    },
    getParsedModel(model) {
      return model.label + " " + model.description;
    },
    async handleConfirmUpdate() {
      this.updateModal = true;
    }
  }
}
</script>

